<template>
  <div class="row help-wrapper">
    <div id="corpo" class="col s12 m8 mensagem-about-geral">
      <h5 class="center">
        Informações
      </h5>
      <div class="input-field col s12" v-if="showMunicipioSelect === true">
        <select v-model="selectedMunicipio" @change="handlerChange">
          <option :value="null" disabled ref="teste">Selecione Municipio ou Estado</option>
          <option v-for="(municipio, i) in meta.censo_domain" v-bind:key="i" v-bind:value="i" :id="i">{{ municipio.nome }}</option>
        </select>
      </div>
      <template v-if="selectedMunicipio !== null ">
        <template v-for="(item, index) in Object.entries(meta.censo_domain[selectedMunicipio].documentos_servidores)">  <!-- item é um Array com a primeira posição sendo um título e a segunda uma lista de documentos -->
          <h6 v-bind:key="index" class="center" v-html="item[0]"></h6> <!-- item[0] é igual a títulos -->
          <template >
            <ul v-bind:key="index+5" class="lista-documentos">
              <template v-for="documento in item[1]"> <!-- item[1] é igual a lista de documentos -->
                <li v-bind:key="documento"><i class="material-icons">check</i>
                <span v-html="documento"></span>
                </li>
              </template>
            </ul>
          </template>
        </template>
        <p v-html="meta.censo_domain[selectedMunicipio].decreto_descripition"></p>
        <router-link v-bind:to="last_page" class="waves-effect waves-light btn btn-theme fAboutLogin col s8" id="abouBtnLogin">
          Voltar
        </router-link>
      </template>
    </div>
  </div>
</template>
<script>
import axios from 'axios' //5350746737874881475

import Loading from '@/components/Loading.vue'
import HeaderAbout from "@/components/HeaderAbout.vue"

import {formataData, converteTimestamp, converteData, converteDataHora} from '@/assets/js/form-utils.js'
import SocialService from '@/services/social-service.js'
import {CONFIG} from '@/config/config.js'
import MunicipioSeletor from '../mixins/municipioSeletor'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'Info',
  mixins: [MunicipioSeletor],
  components: {
    loading: Loading,
    "header-about": HeaderAbout
  },
  data (){
    return {
      last_page: this.$store.state.route.from.fullPath,
      meta: this.$store.state.meta.data,
      selectedMunicipio: null,
      showMunicipioSelect: true
    }
  },
  methods: {
    handlerChange(){
      if(this.selectedMunicipio !== null) {
        localStorage.setItem('selectedMunicipio', this.selectedMunicipio)
      }s
    },
  },
  mounted(){
    this.municipioSeletor()
    setTimeout(() => M.FormSelect.init(document.querySelectorAll('select')), 100)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Info.vue